<template>
    <div class="container-resizable" style="background-color: #ffffff;">
        <div class="p-grid">
            <div class="p-md-12"></div>
            <div class="p-md-2"></div>
            <div class="p-md-8 container-data">
                <h2 class="p-text-center">{{$t("messages.nuestrosMediosDePago")}}</h2>
                <hr class="p-mt-2 p-mb-2"/>
                <div class="p-grid p-justify-center">
                    <div class="p-md-4 p-d-flex p-align-center p-justify-center">
                        <h3 class="p-text-center">{{ $t("messages.tarjetasDebidoYCredito") }}</h3>        
                    </div>                    
                    <div class="p-md-8 p-d-flex p-align-center p-justify-center">
                        <img class="style-tarjetas" src="/assets/layout/images/tarjetas.jpeg" alt="tarjetas" />
                    </div>
                </div>                
                <hr class="p-mt-2 p-mb-2"/>
                <div class="p-grid p-justify-center">
                    <div class="p-md-4 p-d-flex p-align-center p-justify-center">
                        <h3 class="p-text-center">{{ $t("messages.transferenciasBancarias") }}</h3>        
                    </div>                    
                    <div class="p-md-8 p-d-flex p-align-center p-flex-column">
                        <img src="/assets/layout/icons/logo-bancolombia.jpg" alt="logo bancolombia" width="40%" />
                        <img src="/assets/layout/icons/logo_bbva.png" alt="logo bbva" width="35 %" />
                    </div>
                </div>                
                <hr class="p-mt-2 p-mb-2"/>
                <div class="p-grid p-justify-center">
                    <div class="p-md-4 p-d-flex p-align-center p-justify-center">
                        <h3 class="p-text-center">{{ $t("messages.escanesBancolombia") }}</h3>                             
                    </div>                    
                    <div class="p-md-8 p-d-flex p-align-center p-flex-wrap p-justify-center">
                        <img class="qr-style" src="/assets/layout/images/QRBancolobiaQualityCare.jpeg" alt="qr bancolombia" />
                    </div>
                </div>                
                <hr class="p-mt-2 p-mb-2"/>
                <div class="p-grid p-justify-center">
                    <div class="p-md-4 p-d-flex p-align-center p-justify-center">
                        <h3 class="p-text-center">{{ $t("messages.cash") }}</h3>        
                    </div>                    
                    <div class="p-md-8 p-d-flex p-align-center p-justify-center">
                        <img src="/assets/layout/icons/money.png" alt="efectivo" width="80vw" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "MediosDePago"
}
</script>

<style lang="scss" scoped>
.container-resizable {
    justify-content: center;
    background-color: #FFFFFF;
}

.container-data {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    padding-left: 30px;
}

.container-data h2 {
    color: #083078;
    font-size: 40px;
    font-weight: bolder;
}

.container-data p {
    color: #083078;
    font-size: 25px;
}

.container-image {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
}

ul {
    font-size: 20px;

    li {
        margin-top: 20px;
    }
}

.container-qr {
    display: flex;
    align-items: center;
    margin-top: 40px;
    padding: 20px;
    border: 3px solid gray;
}

.qr-style {
    width: 15vw;
    margin-right: 10px;
}

.style-tarjetas{
    width: 15vw;
}
h3{
    color:#083078;
}

@media screen and (max-width: 1540px) {
    .container-resizable {
        padding: 30px 10px;
    }

    .container-data h2 {
        font-size: 40px;
    }

    .container-data p {
        font-size: 20px;
    }
}

@media screen and (max-width: 955px) {
    .container-data h2 {
        margin-top: 30px;
    }

    .container-image {
        justify-content: center;
        width: 100%;

        img {
            width: 100%;
            margin: 0px auto;
        }
    }

    .container-data {
        padding: 10px;
    }

    .container-qr {
        display: flex;
        flex-direction: column;
    }

    .qr-style {
        width: 50vw;
        margin-right: 0px;
    }
}

@media screen and (max-width: 764px) {
    .style-tarjetas {
        width: 80vw;
    }
}

@media screen and (max-width: 480px) {    
    .qr-style {
        width: 80vw;
    }
}
</style>